import React, { useState, useRef } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import { Box } from "@mui/material";

import AddHoliday from "./AddHoliday";
import HeaderHoliday from "./HeaderHoliday";

function Holiday() {
  const [currentEvents, setCurrentEvents] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const calendarRef = useRef(null);

  const handleDateClick = (selected) => {
    setSelectedDate(selected.start);
    setOpenModal(true);
  };

  const handleEventClick = (selected) => {
    if (
      window.confirm(
        `Are you sure you want to delete the holiday '${selected.event.title}'`
      )
    ) {
      selected.event.remove();
    }
  };

  const handleAddHoliday = (title, date) => {
    const calendarApi = calendarRef.current.getApi();
    
    if (title && date) {
      calendarApi.addEvent({
        id: `${date.toISOString()}-${title}`,
        title,
        start: date,
        allDay: true,
      });
    }
  };

  return (
    <Box sx={{ bgcolor: "#eff1f1" }}>
      <HeaderHoliday />
      <AddHoliday 
        open={openModal}
        setOpen={setOpenModal}
        selectedDate={selectedDate}
        onAddHoliday={handleAddHoliday}
      />

      <Box flex="1 1 100%" sx={{ background: "#fff", color: "#000" }}>
        <FullCalendar
          ref={calendarRef}
          height="75vh"
          plugins={[
            dayGridPlugin,
            timeGridPlugin,
            interactionPlugin,
            listPlugin,
          ]}
          headerToolbar={{
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay,listMonth",
          }}
          initialView="dayGridMonth"
          editable={true}
          selectable={true}
          selectMirror={true}
          dayMaxEvents={true}
          select={handleDateClick}
          eventClick={handleEventClick}
          eventsSet={(events) => setCurrentEvents(events)}
        />
      </Box>
    </Box>
  );
}

export default Holiday;